import {Component, Inject, Input} from '@angular/core';
import {MX_INFORMATION_SERVICE_TOKEN, MxInformationService} from '../../../shared/services/mx-information.service';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../shared/services/mx-translate.service";


export type LinkType = 'faq' | 'user_guide';

export interface MxInformationTooltipConfig {
    header: string;
    headerIcon?: string;
    content: string;
    iconName?: string;
    iconColor?: string;
    links: { type: LinkType, id: string, text?: string }[];
}

@Component({
    selector: 'mx-info-tooltip',
    standalone: false,
    templateUrl: './mx-info-tooltip.component.html',
    styleUrls: ['./mx-info-tooltip.component.scss']
})
export class MxInfoTooltipComponent {
    @Input()
    config: MxInformationTooltipConfig;


    constructor(
        @Inject(MX_INFORMATION_SERVICE_TOKEN) private informationService: MxInformationService,
        @Inject(MX_TRANSLATE_SERVICE_TOKEN) private translateService: MxTranslateService,
    ) {
    }

    getUserGuideLink(id: string): string {
        return `${this.informationService.getUserGuideLink()}#${id}`;
    }

    getLabel(label: string): string {
        return this.translateService.getTranslatedLabel(label);
    }
}
